<template>
  <div class="waiting texture-bg-css text-center text-grey">
    <Icon type="md-build" /> 正在建设中……
  </div>
</template>

<script>
export default {
  name: 'Waiting',
  scrollToTop: true,
  components: {},
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.waiting {
  height: 50vh;
  line-height: 50vh;
  font-size: 1.5vw;
}
</style>
